document.addEventListener("DOMContentLoaded", () => { 
  const container = document.querySelector(".all_videosWrap");
  if (!container) return;

  const cards = Array.from(container.querySelectorAll(".videoCard"));
  const loader = container.querySelector(".videoLoader");
  const isMobile = window.innerWidth <= 749;
  const batchSize = isMobile ? 5 : 15;
  let currentIndex = 0;
  let loading = false;

  // Hide all initially
  cards.forEach(card => (card.style.display = "none"));

  // function loadNextBatch() {
  //   if (loading) return;
  //   loading = true;
  //   if (loader) loader.style.display = "flex";

  //   setTimeout(() => {
  //     const nextBatch = cards.slice(currentIndex, currentIndex + batchSize);
  //     nextBatch.forEach(card => (card.style.display = ""));
  //     currentIndex += batchSize;

  //     if (currentIndex >= cards.length) {
  //       if (loader) loader.style.display = "none";
  //       observer.disconnect();
  //     }

  //     loading = false;
  //   }, 400);
  // }
  function loadNextBatch() {
    if (loading) return;
    loading = true;
    if (loader) loader.style.display = "flex";

    setTimeout(() => {
      const nextBatch = cards.slice(currentIndex, currentIndex + batchSize);
      nextBatch.forEach(card => (card.style.display = ""));
      currentIndex += batchSize;

      // 🧮 Desktop: ensure full rows of 5 only
      if (!isMobile) {
        const visibleCards = cards.filter(c => c.style.display !== "none");
        const remainder = visibleCards.length % 5;

        if (remainder !== 0) {
          // Hide the last incomplete row
          visibleCards
            .slice(visibleCards.length - remainder)
            .forEach(card => (card.style.display = "none"));
        }
      } 

      if (currentIndex >= cards.length) {
        if (loader) loader.style.display = "none";
        if (observer) observer.disconnect();
      }

      loading = false;
    }, 400);
  }


  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) loadNextBatch();
      });
    },
    { threshold: 0.5 }
  ); 

  if (loader) observer.observe(loader);
  loadNextBatch();

  // ===============================
  // 🎬 POPUP VIDEO PLAYER
  // ===============================
  const popup = document.querySelector(".prodVideo_ContentWrap");
  const overlay = popup.querySelector(".popOverlay");
  const closeBtn = popup.querySelector(".closeBtn");
  const prevBtn = popup.querySelector(".prevVideo");
  const nextBtn = popup.querySelector(".nextVideo");
  const sliderContainer = popup.querySelector(".prodVideoSlider");

  let slickInitialized = false;
  let currentVideo = null;
  let progressInterval;
  let scrollTop = 0;
  let lastViewedIndex = 0; // ✅ store last watched video index

  const videoEls = cards.map(card => card.querySelector(".media_video video"));

  function openPopup(startIndex = 0) {
    scrollTop = window.scrollY;
    document.body.classList.add("noScroll");
    document.body.style.top = `-${scrollTop}px`;

    popup.style.display = "flex";
    popup.classList.add("openModal");
    sliderContainer.innerHTML = "";

    videoEls.forEach((video, i) => {
      if (!video) return;

      const cloned = video.cloneNode(true);
      cloned.removeAttribute("autoplay");
      cloned.removeAttribute("loop");
      cloned.setAttribute("playsinline", "");
      cloned.setAttribute("webkit-playsinline", "");
      cloned.preload = "none";
      cloned.muted = true;
      cloned.setAttribute("muted", "true");

      const relatedCard = cards[i];
      const videoTitle = relatedCard?.dataset.title || "";
      const videoUrl = relatedCard?.dataset.url || "";

      console.log("relatedCard", relatedCard);

      const slide = document.createElement("div");
      slide.classList.add("slideItem");
      slide.innerHTML = `
        <div class="videoWrap" data-title="${videoTitle}">
          ${cloned.outerHTML}
          <a href="${videoUrl}" class="shopLink">Shop Now</a>
          <div class="progress-soundWrap">
            <div class="progressBarWrap"><div class="progressBar"></div></div>
            <button class="soundControl muted"></button>
            <div class="like-section">
                <span class="like-btn" style="cursor:pointer;">
                  <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                    <path d="M8.39062 18.4907V8.33071C8.39062 7.93071 8.51062 7.54071 8.73062 7.21071L11.4606 3.15071C11.8906 2.50071 12.9606 2.04071 13.8706 2.38071C14.8506 2.71071 15.5006 3.81071 15.2906 4.79071L14.7706 8.06071C14.7306 8.36071 14.8106 8.63071 14.9806 8.84071C15.1506 9.03071 15.4006 9.15071 15.6706 9.15071H19.7806C20.5706 9.15071 21.2506 9.47071 21.6506 10.0307C22.0306 10.5707 22.1006 11.2707 21.8506 11.9807L19.3906 19.4707C19.0806 20.7107 17.7306 21.7207 16.3906 21.7207H12.4906C11.8206 21.7207 10.8806 21.4907 10.4506 21.0607L9.17062 20.0707C8.68062 19.7007 8.39062 19.1107 8.39062 18.4907Z" fill="currentColor"></path>
                    <path d="M5.21 6.37891H4.18C2.63 6.37891 2 6.97891 2 8.45891V18.5189C2 19.9989 2.63 20.5989 4.18 20.5989H5.21C6.76 20.5989 7.39 19.9989 7.39 18.5189V8.45891C7.39 6.97891 6.76 6.37891 5.21 6.37891Z" fill="currentColor"></path>
                  </svg>
                  <span class="like-count"></span>
                </span>
            </div>
            <button class="shareBtn" data-share="${videoUrl}" style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 227.216 227.216" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M175.897 141.476c-13.249 0-25.11 6.044-32.98 15.518l-51.194-29.066a42.671 42.671 0 0 0 2.467-14.317 42.67 42.67 0 0 0-2.467-14.316l51.19-29.073c7.869 9.477 19.732 15.523 32.982 15.523 23.634 0 42.862-19.235 42.862-42.879C218.759 19.229 199.531 0 175.897 0 152.26 0 133.03 19.229 133.03 42.865c0 5.02.874 9.838 2.467 14.319L84.304 86.258c-7.869-9.472-19.729-15.514-32.975-15.514-23.64 0-42.873 19.229-42.873 42.866 0 23.636 19.233 42.865 42.873 42.865 13.246 0 25.105-6.042 32.974-15.513l51.194 29.067a42.67 42.67 0 0 0-2.468 14.321c0 23.636 19.23 42.865 42.867 42.865 23.634 0 42.862-19.23 42.862-42.865.001-23.64-19.227-42.874-42.861-42.874zm0-126.476c15.363 0 27.862 12.5 27.862 27.865 0 15.373-12.499 27.879-27.862 27.879-15.366 0-27.867-12.506-27.867-27.879C148.03 27.5 160.531 15 175.897 15zM51.33 141.476c-15.369 0-27.873-12.501-27.873-27.865 0-15.366 12.504-27.866 27.873-27.866 15.363 0 27.861 12.5 27.861 27.866 0 15.364-12.499 27.865-27.861 27.865zm124.567 70.74c-15.366 0-27.867-12.501-27.867-27.865 0-15.37 12.501-27.875 27.867-27.875 15.363 0 27.862 12.505 27.862 27.875 0 15.364-12.499 27.865-27.862 27.865z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg>
            </button>
          </div>
        </div>`;
        // slide.innerHTML = `
        // <div class="videoWrap" data-title="${videoTitle}">
        //   ${cloned.outerHTML}
        //   <div class="progress-soundWrap">
        //     <div class="progressBarWrap"><div class="progressBar"></div></div>
        //     <button class="soundControl muted"></button>
        //   </div>
        // </div>`;
      sliderContainer.appendChild(slide);
    });

    initSlick(startIndex);
    initAllCards(); // 👍 populate like counts after slides are added
    

    document.querySelectorAll('.shareBtn').forEach(btn => {
      btn.addEventListener('click', () => {
        const shareUrl = btn.dataset.share;

        // If browser supports native share dialog (mobile)
        if (navigator.share) {
          navigator.share({
            title: document.title,
            url: shareUrl,
          }).catch(() => {});
        } 
        else {
          // Copy fallback
          navigator.clipboard.writeText(shareUrl).then(() => {
            alert("Link copied!");
          });
        }
      });
    });
  }


  function initSlick(startIndex = 0) {
    if (slickInitialized) $(sliderContainer).slick("unslick");

    $(sliderContainer).slick({
      vertical: true,
      infinite: false,
      arrows: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: startIndex,
      verticalSwiping: window.innerWidth <= 749,
      swipeToSlide: true,
      touchThreshold: 10, // 👈 much lighter drag
      speed: 180,         // 👈 faster transition
      cssEase: "linear",// 👈 smoother easing
      waitForAnimate: false, // 👈 prevents blocking next swipe
      adaptiveHeight: false
    });

    slickInitialized = true;

    $(sliderContainer).on("afterChange", (e, slick, currentSlide) => {
      lastViewedIndex = currentSlide;
      setTimeout(() => playCurrentVideo(currentSlide), 150);
    });

    lastViewedIndex = startIndex;
    setTimeout(() => playCurrentVideo(startIndex), 150);
  }

  function playCurrentVideo(index) {
    pauseAllVideos();

    const slides = sliderContainer.querySelectorAll(".slideItem");
    const activeSlide = slides[index];
    if (!activeSlide) return;

    currentVideo = activeSlide.querySelector("video");
    const progressBar = activeSlide.querySelector(".progressBar");
    const progressWrap = activeSlide.querySelector(".progressBarWrap");
    const soundBtn = activeSlide.querySelector(".soundControl");

    if (!currentVideo) return;

    try { currentVideo.load(); } catch {}
    currentVideo.currentTime = 0;
    currentVideo.style.display = "block";
    currentVideo.muted = false;
    soundBtn.classList.remove("muted");

    const tryPlay = () => {
      const playPromise = currentVideo.play();
      if (playPromise && typeof playPromise.then === "function") {
        playPromise.catch(() => {
          currentVideo.muted = true;
          soundBtn.classList.add("muted");
          currentVideo.play().catch(() => {});
        });
      }
    };

    if (currentVideo.readyState < 2) {
      currentVideo.addEventListener("loadeddata", tryPlay, { once: true });
    } else {
      tryPlay();
    }

    // ✅ Progress bar tracking
    clearInterval(progressInterval);
    progressInterval = setInterval(() => {
      if (currentVideo && currentVideo.duration) {
        progressBar.style.width =
          (currentVideo.currentTime / currentVideo.duration) * 100 + "%";
      }
    }, 100);

    // ✅ Sound toggle
    soundBtn.onclick = () => {
      currentVideo.muted = !currentVideo.muted;
      soundBtn.classList.toggle("muted", currentVideo.muted);
    };

    // ✅ Play next video when done
    currentVideo.onended = () => $(sliderContainer).slick("slickNext");

    // ✅ Make progress bar draggable & seekable
    let isDragging = false;

    const seek = (e) => {
      const rect = progressWrap.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const ratio = Math.min(Math.max(0, (clientX - rect.left) / rect.width), 1);
      const newTime = ratio * currentVideo.duration;
      currentVideo.currentTime = newTime;
      progressBar.style.width = ratio * 100 + "%";
    };

    const startDrag = (e) => {
      if (!currentVideo.duration) return;
      isDragging = true;
      currentVideo.pause();
      seek(e);
      document.addEventListener("mousemove", seek);
      document.addEventListener("mouseup", endDrag);
      document.addEventListener("touchmove", seek);
      document.addEventListener("touchend", endDrag);
    };

    const endDrag = (e) => {
      if (!isDragging) return;
      isDragging = false;
      seek(e);
      document.removeEventListener("mousemove", seek);
      document.removeEventListener("mouseup", endDrag);
      document.removeEventListener("touchmove", seek);
      document.removeEventListener("touchend", endDrag);
      currentVideo.play();
    };

    progressWrap.addEventListener("mousedown", startDrag);
    progressWrap.addEventListener("touchstart", startDrag);
  }


  function pauseAllVideos() {
    clearInterval(progressInterval);
    sliderContainer.querySelectorAll("video").forEach(v => {
      try {
        v.pause();
        v.currentTime = 0;
      } catch {}
    });
  }

  function closePopup() {
    pauseAllVideos();
    popup.classList.remove("openModal");
    popup.style.display = "none";
    if (slickInitialized) $(sliderContainer).slick("unslick");
    slickInitialized = false;
    sliderContainer.innerHTML = "";

    document.body.classList.remove("noScroll");
    document.body.style.top = "";
    window.scrollTo(0, scrollTop);

    // ✅ Wait until the videoCards are all visible (lazy loading fix)
    const scrollToLastViewed = () => {
      if (!cards[lastViewedIndex]) return;
      const targetCard = cards[lastViewedIndex];
      targetCard.scrollIntoView({ behavior: "smooth", block: "center" });
    };

    // If the target card is not visible yet (lazy load), force-load batches until it is.
    const ensureVisible = () => {
      if (cards[lastViewedIndex].style.display === "none") {
        loadNextBatch();
        setTimeout(ensureVisible, 300);
      } else {
        setTimeout(scrollToLastViewed, 300);
      }
    };
    ensureVisible();
  }

  [overlay, closeBtn].forEach(el => el.addEventListener("click", closePopup));
  prevBtn.addEventListener("click", () => $(sliderContainer).slick("slickPrev"));
  nextBtn.addEventListener("click", () => $(sliderContainer).slick("slickNext"));

  document.addEventListener("keydown", e => {
    if (e.key === "Escape" && popup.classList.contains("openModal")) closePopup();
  });

  cards.forEach((card, index) => {
    const mediaWrap = card.querySelector(".mediaWrap");
    if (mediaWrap) {
      mediaWrap.addEventListener("click", e => {
        e.preventDefault();
        openPopup(index);

        initAllCards();
      });
    }
  });
});
